import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, Self, SimpleChanges,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NgControl,
  ValidationErrors, Validator,
  Validators
} from "@angular/forms";
import * as _ from "lodash";

require('./bringoz-multi-select.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-bringoz-multi-select',
  templateUrl: './bringoz-multi-select.html',
})
export class BringozMultiSelectComponent implements ControlValueAccessor, Validator, OnInit, OnChanges {

  @Input() selectedValues: string[];
  @Input() options: string[];
  @Input() required = false;
  @Input() label: string;
  @Output() onValueChange = new EventEmitter<string>();

  public selectedKeys: any;

  constructor(@Optional() @Self() @Inject(NgControl) public control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  ngOnInit() {
    this.initSelectedValuesMap();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options && !changes.options.isFirstChange()) {
      this.initSelectedValuesMap();
    }
  }


  writeValue(value: any): void {
    this.selectedValues = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onChange = (value: any) => {
  };
  onTouched = () => {
  };

  onSelectionChange(values: any) {
    this.selectedValues = values;
    this.onChange(values);
    this.onTouched();
    this.onValueChange.emit(values);
    this.initSelectedValuesMap();
  }

  getValidator() {
    return Validators.compose([Validators.required]);
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    const validator = this.getValidator?.();
    if (!validator) {
      return null;
    }
    return validator(control);
  }


  private initSelectedValuesMap() {
    this.selectedKeys = {};
    _.forEach(this.selectedValues, (id) => {
      this.selectedKeys[id] = true;
    });
  }

}
